import { render, staticRenderFns } from "./indexCopy.vue?vue&type=template&id=2a1de5c5&scoped=true&"
import script from "./indexCopy.vue?vue&type=script&lang=js&"
export * from "./indexCopy.vue?vue&type=script&lang=js&"
import style0 from "./indexCopy.vue?vue&type=style&index=0&id=2a1de5c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1de5c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a1de5c5')) {
      api.createRecord('2a1de5c5', component.options)
    } else {
      api.reload('2a1de5c5', component.options)
    }
    module.hot.accept("./indexCopy.vue?vue&type=template&id=2a1de5c5&scoped=true&", function () {
      api.rerender('2a1de5c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/list/indexCopy.vue"
export default component.exports